import React, {useEffect, useState} from "react";
import {getStockValuationFxn} from "../actions";
import {Card, Table} from "../../../components/Elements/appUtils";

const CurrentStockValuation = () => {
    const [reportData, setReportData] = useState([]);
    const [totalValuation, setTotalValuation] = useState(0);
    const [openingValue, setOpeningValue] = useState(0);
    const getReportFxn = async (params = {}) => {
        try {
            const {data = {}, totalValue} = await getStockValuationFxn({...params});
            setReportData(data);
            setTotalValuation(totalValue);
            setOpeningValue(openingValue);

        } catch (error) {
            setReportData([]);
            setTotalValuation(0);
        }
    };

    // Initial load
    useEffect(() => {
        getReportFxn();
    }, []);


    const columns = [
        {
            title: "Sr. No",
            dataIndex: "serialNo",
            key: "serialNo",
            render: (text, record, index) => index + 1,
        },
        {
            title: "Product Name",
            dataIndex: "productName",
            key: "productName",
            width: 200,
        },
        {
            title: "Product Code",
            dataIndex: "code",
            key: "code",
        },
        {
            title: "HSN",
            dataIndex: "hsnCode",
            key: "hsnCode",
        },

        {
            title: "Amount",
            dataIndex: "totalAmount",
            key: "totalAmount",
            render: (item) => {
                return item ? `Rs. ${item.toFixed(2)}` : null
            }
        },
        {
            title: "Batch",
            dataIndex: "records",
            key: "records",
            width: '40%',
            render: (record) => {
                return (
                    <>
                        <table className={'table-sm stock_value_table'}>
                            <tr>
                                <th>Batch</th>
                                <th>Purchase Price</th>
                                <th>MRP</th>
                            </tr>
                            {record.map((item) => {
                                return (
                                    <tr key={item._id}>
                                        <td>{item.batchNo}</td>
                                        <td>{item.quantity} x
                                            Rs. {item.purchasePrice} = <strong>Rs. {item.totalPurchasePrice.toFixed(2)}</strong>
                                        </td>
                                        <td>{item.quantity} x
                                            Rs. {item.price} = <strong>Rs. {item.total.toFixed(2)}</strong></td>
                                    </tr>
                                )
                            })}
                        </table>
                        {/*<ul className={'ul-sm'}>
                            {record.map((item) => {
                                return (
                                    <li key={item._id}>
                                        <div>
                                            <span>{item.batchNo}</span>
                                            <span>{item.quantity} x Rs. {item.purchasePrice} = <strong>Rs. {item.totalPurchasePrice.toFixed(2)}</strong></span>
                                            <span>{item.quantity} x Rs. {item.price} = <strong>Rs. {item.total.toFixed(2)}</strong></span>
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>*/}
                    </>
                )
            }
        },
    ];

    return (
        <Card title={`Stock Valuation`} actions={(
            <>
                Total Valuation : <strong>Rs. {totalValuation?.toFixed(2)}</strong>
            </>
        )}>

            <div className="row ">
                <div className="col-md-12" key={reportData.length}>
                    <div>
                        <Table
                            dataSource={reportData}
                            columns={columns}
                            rowKey="_id"
                        />
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default CurrentStockValuation;
